import { render, staticRenderFns } from "./swLegalKitkit.vue?vue&type=template&id=f1c979fa&scoped=true&"
import script from "./swLegalKitkit.vue?vue&type=script&lang=js&"
export * from "./swLegalKitkit.vue?vue&type=script&lang=js&"
import style0 from "./swLegalKitkit.vue?vue&type=style&index=0&id=f1c979fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c979fa",
  null
  
)

export default component.exports